import { cn } from "@/lib/utils";

interface SpinnerProps {
  className?: string;
  message?: string;
  size?: "sm" | "default" | "lg";
}

export function Spinner({ className, message, size = "default" }: SpinnerProps) {
  const sizeClasses = {
    sm: "h-4 w-4 border-[1.5px]",
    default: "h-5 w-5 border-2",
    lg: "h-8 w-8 border-2",
  };

  return (
    <div className={cn("flex flex-col items-center justify-center gap-3 py-12", className)}>
      <div
        className={cn(
          "animate-spin rounded-full border-slate-200 border-t-brand-600",
          sizeClasses[size]
        )}
      />
      {message && (
        <p className="text-sm text-slate-500 animate-subtle-pulse">{message}</p>
      )}
    </div>
  );
}
